<template>
    <div ref="historyRef" class="tag" :class="{'tag-show-all': showPackUp}">
        <div class="item-search-tag" v-for="(item, index) in tagList" :key="item">
            <div class="value" @click="clickTag(item, index)">
                {{ item }}
            </div>
            <div
                @click="packUp"
                ref="icon"
                class="value icon"
                v-if="index === iconShow - 1"
            >
                <svg
                    v-if="!showPackUp"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M14.75 7.125L9 12.875L3.25 7.125"
                        stroke="var(--font-common, #222)"
                        stroke-width="1.5"
                        stroke-linecap="square"
                    />
                </svg>
                <svg
                    v-else
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M3.25 10.875L9 5.125L14.75 10.875"
                        stroke="var(--font-common, #222)"
                        stroke-width="1.5"
                        stroke-linecap="square"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'history-tag',
    props: {
        tagList: {
            type: Array,
            default: () => [],
        },
    },
    watch: {
        tagList: {
            immediate: true,
            deep: true,
            handler(value) {
                if (value.length) {
                    this.updateIcon();
                } else {
                    this.showPackUp = false;
                    this.iconShow = -1;
                    this.exporeIndex = -1;
                }
            },
        },
    },
    data() {
        return {
            showPackUp: false,
            iconShow: -1,
            exporeIndex: -1,
        };
    },
    methods: {
        /**
         * 处理弹窗场景，重新计算图标位置
         */
        reRender() {
            if (this.tagList.length) {
                this.updateIcon();
            } else {
                this.showPackUp = false;
                this.iconShow = -1;
                this.exporeIndex = -1;
            }
        },
        clickTag(item, index) {
            this.$emit('clickTag', item, index);
        },
        updateIcon() {
            if (!this.showPackUp) {
                this.iconShow = -1;
                this.exporeIndex = -1;
                this.$nextTick(() => {
                    this.updateIconPosition();
                });
            } else {
                this.iconShow = this.tagList.length;
            }
        },
        updateIconPosition() {
            this.iconShow = -1;
            this.exporeIndex = -1;
            const fontSize = document.documentElement.style.fontSize;
            const fontSizeNumber = Number(fontSize.substring(0, fontSize.length - 2));
            const tagListEl = this.$refs.historyRef.childNodes;
            const tagList = Array.from(tagListEl);
            const index = tagList.findIndex(item => {
                return item.offsetTop >= this.$refs.historyRef.offsetHeight;
            });
            const tagArr = tagList.slice(0, index);
            let index1 = -1;
            if (Array.from(tagArr).length && index !== -1) {
                for (let i = index; i >= 0; i--) {
                    const element = Array.from(tagArr)[i - 1];
                    const distance = element.offsetLeft + element.offsetWidth + 0.31 * fontSizeNumber + 0.08 * fontSizeNumber;
                    if (distance < this.$refs.historyRef.offsetWidth && element.offsetTop !== tagList[0].offsetTop) {
                        index1 = i;
                        break;
                    }
                }
            }
            this.iconShow = index1;
            this.exporeIndex = index1;
        },
        packUp() {
            this.showPackUp = !this.showPackUp;
            this.iconShow = this.showPackUp ? this.tagList.length : this.exporeIndex;
            this.updateIcon();
        },
    },
};
</script>
<style lang="less" scoped>
.tag-show-all {
        max-height: 9rem !important;
        transition: max-height 2s;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        z-index: 1;
        transform: translate3d(0,0,0);
    }
    .tag {
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.1rem;
        max-height: 0.78rem;
        overflow: hidden;
        position: relative;
        .item-search-tag {
            display: flex;
            align-items: center;
            .icon {
                display: flex !important;
                justify-content: center;
                align-items: center;
                padding: 0 0.07rem !important;
            }
            .value {
                background: var(--button-bg, #fff);
                color: var(--font-common, #222);
                font-size: .15rem;
                max-width: 1.2rem;
                display: inline-block;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 0 .1rem;
                height: .31rem;
                line-height: .31rem;
                border-radius: .08rem;
                margin-right: .08rem;
            }
            .icon {
                background: var(--button-bg, #fff);
            }
            margin: .04rem 0;
        }
    }
</style>
